module.exports = "<div class=\"toast\" *ngIf=\"toastMessage$ | async\" [@toastAnimation]>\r\n\t<i *ngIf=\"(toastMessage$ | async)?.showWarningIcon\" class=\"icon-status-bar-alert\"></i>\r\n\t{{(toastMessage$ | async)?.toastText}}\r\n\t<span (click)=\"closeToast()\">×</span>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/src/app/packages/core/components/toast/toast.component.html
// module id = ../../../../../src/app/packages/core/components/toast/toast.component.html
// module chunks = main